const customer = {
    navigation: {
      overview: 'Übersicht',
      subscriptions: 'Abonnements',
      billing: 'Abrechnung',
      credits: 'Credits',
      teams: 'Teams',
      settings: 'Einstellungen',
    },
    portal: {
      accountFallback: 'Kundenkonto',
      profileComingSoon: 'Profilverwaltung folgt in Kürze',
      comingSoon: {
        intro: 'Wir rollen diesen Bereich des Portals schrittweise aus, damit er zu den kommenden React-19-Funktionen passt.',
        support: 'Sie müssen heute eine Änderung vornehmen? Wenden Sie sich an Ihren Provider-Admin oder schreiben Sie an support@florentin.app – wir helfen weiter.',
      },
      login: {
        title: 'Greife auf dein Kundenportal zu',
        description: 'Gib die E-Mail-Adresse ein, die mit deinem {{provider}}-Abonnement verbunden ist. Wir senden einen 6-stelligen Code zur Verifizierung.',
        passwordDescription: 'Nutze die E-Mail-Adresse und das Passwort deines anymize.ai-Kundenkontos zur Anmeldung.',
        emailLabel: 'E-Mail-Adresse',
        emailPlaceholder: 'owner@example.com',
        submit: 'Einmalcode senden',
        submitting: 'Code wird gesendet…',
        magicTab: 'Magic Link',
        passwordTab: 'Passwort',
        passwordLabel: 'Passwort',
        passwordPlaceholder: 'Dein Passwort',
        otpLabel: 'Sicherheitscode (optional)',
        passwordSubmit: 'Mit Passwort anmelden',
        passwordSubmitting: 'Anmeldung läuft…',
        passwordLoginDisabled: 'Die Passwort-Anmeldung ist für dieses Kundenportal deaktiviert.',
        invalidCredentials: 'E-Mail oder Passwort sind ungültig.',
        registerPrompt: 'Musst du ein Konto registrieren?',
        registerCta: 'Kundenprofil erstellen',
        tip: 'Tipp: Codes laufen nach wenigen Minuten ab. Du kannst einen neuen anfordern, wenn der alte abläuft.',
        providerPrompt: 'Benötigst du stattdessen Provider-Zugang?',
        providerCta: 'Zur Provider-Anmeldung',
        invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
        sendCodeError: 'Der Verifizierungscode konnte nicht gesendet werden. Bitte versuche es später erneut.',
        usePassword: 'Passwort verwenden',
        useSignInCode: 'Anmeldecode verwenden',
        forgotPassword: 'Passwort setzen oder zurücksetzen',
        errors: {
          emailNotVerified: 'Bitte bestätige deine E-Mail-Adresse, bevor du dich anmeldest.',
        },
      },
      forgotPassword: {
        title: 'Passwort setzen oder zurücksetzen',
        description: 'Gib die E-Mail-Adresse deines Kundenkontos ein, damit wir dir einen Link zum Setzen oder Zurücksetzen deines Passworts senden können.',
        submit: 'Passwort-Link senden',
        submitting: 'Link wird gesendet...',
        success: 'Wenn ein Konto existiert, wurde ein Link zum Setzen oder Zurücksetzen des Passworts gesendet.',
        backToLogin: 'Zurück zum Login',
        error: 'Passwort-Link konnte nicht gesendet werden. Bitte versuche es erneut.',
      },
      resetPassword: {
        title: 'Neues Passwort erstellen',
        description: 'Lege ein neues Passwort fest, um auf dein Kundenportal zuzugreifen.',
        passwordLabel: 'Neues Passwort',
        passwordPlaceholder: 'Neues Passwort erstellen',
        confirmPasswordLabel: 'Neues Passwort bestätigen',
        confirmPasswordPlaceholder: 'Neues Passwort bestätigen',
        showPassword: 'Passwort anzeigen',
        hidePassword: 'Passwort verbergen',
        submit: 'Passwort zurücksetzen',
        submitting: 'Passwort wird zurückgesetzt...',
        success: 'Passwort erfolgreich zurückgesetzt.',
        backToLogin: 'Zurück zum Login',
        invalidLink: 'Ungültiger oder abgelaufener Reset-Link.',
        invalidToken: 'Ungültiger oder abgelaufener Reset-Token.',
        passwordMismatch: 'Passwörter stimmen nicht überein.',
        error: 'Passwort konnte nicht zurückgesetzt werden. Bitte versuche es erneut.',
      },
      invitation: {
        title: 'Einladung annehmen',
        description: 'Lege dein Passwort fest, um die Kontoerstellung abzuschließen.',
        verifying: 'Einladung wird überprüft…',
        invitationFor: 'Einladung für <strong>{{email}}</strong>',
        passwordLabel: 'Passwort',
        confirmPasswordLabel: 'Passwort bestätigen',
        submitCta: 'Passwort setzen',
        submitting: 'Passwort wird gesetzt…',
        invalidLink: 'Ungültiger oder abgelaufener Einladungslink.',
        missingParams: 'Einladungsparameter fehlen',
        errorFallback: 'Einladung konnte nicht akzeptiert werden',
      },
      verify: {
        title: 'Gib den Verifizierungscode ein',
        description: 'Wir haben einen 6-stelligen Code an <strong>{{email}}</strong> gesendet. Gib ihn ein, um den Login abzuschließen.',
        error: 'Ungültiger oder abgelaufener Code. Bitte versuche es erneut.',
        resendPrompt: 'Nicht erhalten?',
        resendTimer: 'Erneut senden in {{seconds}}s',
        resendCta: 'Code erneut senden',
        verifying: 'Wird verifiziert…',
        verifyCta: 'Code verifizieren',
        useDifferentEmail: 'Andere E-Mail verwenden',
        resendError: 'Der Code konnte momentan nicht erneut gesendet werden. Bitte warte und versuche es erneut.',
      },
    },
    customerSso: {
      missingToken: 'Magic-Link-Token fehlt oder ist ungültig.',
      exchangeFailed: 'Der Magic-Link-Austausch konnte nicht abgeschlossen werden.',
      loadingTitle: 'Sitzung wird wiederhergestellt…',
      loadingMessage: 'Einen Moment bitte, wir melden dich im Kundenportal an.',
      errorTitle: 'Magic Link abgelaufen oder ungültig',
      errorMessage:
        'Fordere einen neuen Portal-Link bei deinem Provider an oder melde dich mit deiner E-Mail an, um fortzufahren.',
      backToLogin: 'Zurück zum Login',
    },
    dashboard: {
      defaultPortalName: 'Kunde',
      providerFallback: 'deinen Provider',
      welcome: 'Willkommen im {{portal}}-Portal',
      subtitle: 'Verfolge deine API-Abonnements, verwalte Teamzugriffe und behalte die Nutzung für {{provider}} im Blick – alles an einem Ort.',
      cards: {
        usage: {
          title: 'Nutzungsübersicht',
          value: '{{count}} Anfragen',
          description: 'Sobald dein Team Traffic sendet, erscheint hier die Live-API-Aktivität.',
        },
        billing: {
          title: 'Abrechnung',
          value: 'Zahlungsmethoden',
          description: 'Prüfe Rechnungen, Salden und gespeicherte Karten im Abrechnungsbereich.',
        },
        teams: {
          title: 'Teams',
          value: 'Zusammenarbeiten',
          description: 'Lade Teammitglieder ein, weise Rollen zu und verwalte Plätze für gemeinsame Produkte.',
        },
        automation: {
          title: 'Automatisierung',
          value: 'API-Schlüssel',
          description: 'Erstelle und rotiere Zugangsdaten direkt im Portal.',
        },
      },
      nextSteps: {
        title: 'Nächste Schritte',
        description: 'Nutze die schnelle Checkliste, um dein Workspace-Setup abzuschließen und dein Team abgestimmt zu halten.',
        checklist: {
          confirmBilling: 'Bestätige deinen Rechnungskontakt und die Zahlungsdaten im Bereich Abrechnung.',
          inviteTeammates: 'Lade Teammitglieder ein und weise Owner-/Member-Rollen im Bereich Teams zu.',
          rotateKeys: 'Rotiere vorhandene API-Schlüssel und dokumentiere Nutzungsrichtlinien für neue Mitglieder.',
        },
      },
    },
    settings: {
      title: 'Kontoeinstellungen',
      subtitle: 'Verwalte Sicherheitsdetails für dein Kundenportal-Konto.',
      categoriesTitle: 'Einstellungskategorien',
      categoriesDescription: 'Konfiguriere dein Konto und deine Plattform-Einstellungen.',
      categories: {
        security: {
          title: 'Sicherheit',
          description: 'Aktualisiere dein Passwort und deine Anmeldeeinstellungen.',
        },
        profile: {
          title: 'Profil',
          description: 'Verwalte deinen Namen und deine Kontaktdaten.',
        },
        notifications: {
          title: 'Benachrichtigungen',
          description: 'Lege fest, wie du Updates erhältst.',
        },
        badges: {
          comingSoon: 'Kommt bald',
        },
      },
      password: {
        title: 'Passwort',
        description: 'Aktualisiere das Passwort, mit dem du dich per E-Mail und Passwort anmeldest.',
        setTitle: 'Passwort festlegen',
        setDescription: 'Lege ein Passwort fest, um dich per E-Mail und Passwort anzumelden.',
        currentLabel: 'Aktuelles Passwort',
        currentPlaceholder: 'Gib dein aktuelles Passwort ein',
        newLabel: 'Neues Passwort',
        newPlaceholder: 'Gib ein neues Passwort ein',
        confirmLabel: 'Neues Passwort bestätigen',
        confirmPlaceholder: 'Gib das neue Passwort erneut ein',
        helper: 'Dein neues Passwort muss den Sicherheitsrichtlinien deines Providers entsprechen.',
        showPassword: 'Passwort anzeigen',
        hidePassword: 'Passwort verbergen',
        submit: 'Passwort aktualisieren',
        submitting: 'Wird aktualisiert...',
        setSubmit: 'Passwort festlegen',
        setSubmitting: 'Wird festgelegt...',
        success: 'Passwort wurde erfolgreich aktualisiert.',
        setSuccess: 'Passwort wurde erfolgreich festgelegt.',
        error: 'Passwort konnte nicht aktualisiert werden. Bitte versuche es erneut.',
        setError: 'Passwort konnte nicht festgelegt werden. Bitte versuche es erneut.',
        unauthorized: 'Bitte melde dich erneut an, um dein Passwort zu aktualisieren.',
        forbidden: 'Deine Sitzung darf dieses Passwort nicht aktualisieren.',
        validation: {
          required: 'Bitte fülle dieses Feld aus.',
          mismatch: 'Die Passwörter stimmen nicht überein.',
          minLength: 'Das Passwort muss mindestens {{count}} Zeichen enthalten.',
          currentIncorrect: 'Das aktuelle Passwort ist falsch.',
          useChangeEndpoint: 'Verwende das Formular zum Passwort-Update, um dein Passwort zu ändern.',
          mixed: 'Das Passwort muss Groß- und Kleinbuchstaben enthalten.',
          symbols: 'Das Passwort muss mindestens ein Symbol enthalten.',
          numbers: 'Das Passwort muss mindestens eine Zahl enthalten.',
        },
      },
    },
  subscriptions: {
      title: 'Abonnements',
      subtitle: 'Verfolge aktive Pläne, Abrechnungszyklen und Verlängerungsdaten.',
      table: {
        plan: 'Plan',
        status: 'Status',
        billing: 'Abrechnung',
        price: 'Preis',
        period: 'Zeitraum',
        actions: 'Aktionen',
      },
      status: {
        active: 'Aktiv',
        trialing: 'In Testphase',
        canceled: 'Gekündigt',
        past_due: 'Überfällig',
        incomplete: 'Unvollständig',
        incomplete_expired: 'Abgelaufen (unvollständig)',
        unpaid: 'Unbezahlt',
        paused: 'Pausiert',
      },
      periodValue: '{{start}} – {{end}}',
      trialUntil: 'Testphase bis {{date}}',
      emptyTitle: 'Noch keine Abonnements',
      emptyDescription: 'Sobald du ein Abonnement startest, erscheint es hier mit seinen Verlängerungsdetails.',
      loading: 'Abonnements werden geladen…',
      error: 'Abonnements konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
  },
  planManagement: {
    currentSubscription: {
      title: 'Dein aktuelles Abonnement',
      description: 'Sieh dir deinen aktuellen Plan und Abrechnungsstatus an.',
      noPlan: 'Kein aktiver Plan',
      nextBilling: 'Nächstes Abrechnungsdatum',
      trialEnds: 'Testphase endet am',
      activeUntil: 'Aktiv bis',
      endedOn: 'Beendet am',
      seats: 'Sitzplatznutzung',
      seatUsage: '{{used}} / {{limit}} Sitze belegt',
    },
    trialExpired: {
      title: 'Deine Testphase ist abgelaufen',
      description: 'Bezahle jetzt, um deinen Plan weiter zu nutzen.',
      payNow: 'Jetzt bezahlen',
    },
    billingIssue: {
      title: 'Zahlung erforderlich',
      incompleteTitle: 'Zahlung unvollständig',
      description: 'Dein Abonnement hat offene Abrechnungsprobleme. Bitte schließe die Zahlung ab, um fortzufahren.',
      cta: 'Zahlung abschließen',
    },
    status: {
      active: 'Aktiv',
      trial: 'Testphase',
      trial_expired: 'Testphase abgelaufen',
      pending_cancellation: 'Kündigung geplant',
      cancelled: 'Gekündigt',
      past_due: 'Überfällig',
      incomplete: 'Unvollständig',
      unpaid: 'Unbezahlt',
      paused: 'Pausiert',
      unknown: 'Unbekannt',
    },
    plans: {
      title: 'Planübersicht',
      description: 'Vergleiche Pläne und verwalte deine Abo-Änderungen.',
      summary: '{{total}} verfügbare Pläne • {{actionable}} direkte Wechseloptionen',
      current: 'Aktuell',
      currentPlan: 'Aktueller Plan',
      customPricing: 'Vertrieb kontaktieren',
      seatLimit: 'Bis zu {{count}} Sitze',
      moreFeatures: '+{{count}} weitere Funktionen',
      searchPlaceholder: 'Pläne suchen',
      searchAria: 'Verfügbare Pläne durchsuchen',
      emptyTitle: 'Keine Pläne gefunden',
      emptyDescription: 'Versuche einen anderen Suchbegriff.',
    },
    actions: {
      upgrade: 'Hochstufen',
      downgrade: 'Herabstufen',
      choosePlan: 'Plan auswählen',
      cancelSubscription: 'Abonnement kündigen',
      resume: 'Fortsetzen',
      activateSubscription: 'Abonnement aktivieren',
      confirmUpgrade: 'Hochstufung bestätigen',
      confirmDowngrade: 'Herabstufung bestätigen',
      confirmCancel: 'Kündigung bestätigen',
      keepCurrent: 'Aktuellen Plan behalten',
      processing: 'Wird verarbeitet...',
      pendingChangeDisabled:
        'Eine Planänderung ist bereits geplant. Du kannst eine weitere Änderung vornehmen, sobald sie wirksam ist.',
      unavailable: 'Kein direkter Wechsel',
      dismiss: 'Schließen',
    },
    reactivation: {
      title: 'Abonnement reaktivieren',
      resumeAllowed: 'Du kannst dein Abonnement fortsetzen und deinen Plan weiter nutzen.',
      checkoutRequired: 'Für die Reaktivierung ist eine Zahlung erforderlich.',
    },
    dialogs: {
      upgradeTitle: 'Auf {{plan}} hochstufen?',
      downgradeTitle: 'Auf {{plan}} herabstufen?',
      upgradeDescription: 'Die Hochstufung tritt sofort entsprechend deiner Abrechnungseinstellungen in Kraft.',
      downgradeDescription: 'Die Herabstufung wird für den nächsten Abrechnungszyklus geplant.',
      cancelTitle: 'Abonnement kündigen?',
      cancelDescription: 'Dein Plan bleibt bis zum Ende des aktuellen Abrechnungszyklus aktiv.',
      cancelActiveUntil: 'Dein Plan bleibt bis {{date}} aktiv.',
    },
    checkout: {
      title: 'Abo-Checkout abschließen',
      description: 'Schließe die Zahlung im Portal ab, um dein Abonnement zu aktivieren.',
      reactivateNoPayment: 'Für die Reaktivierung ist keine Zahlung erforderlich. Fortsetzen, um weiterzumachen.',
      noPaymentTitle: 'Keine Zahlung erforderlich',
      pendingAction: 'Ausstehende Aktion: {{action}}',
      backToPlans: 'Zurück zu den Plänen',
      autoActivationTitle: 'Dein Plan wird aktiviert',
      autoActivationDescription: 'Dein Testplan kann ohne Zahlung automatisch aktiviert werden.',
      autoActivationLoading: 'Dein Testabonnement wird aktiviert…',
      autoActivationRetry: 'Aktivierung erneut versuchen',
      summaryTitle: 'Planübersicht',
      summaryDescription: 'Überprüfe den zu aktivierenden Plan.',
      plan: 'Plan',
      price: 'Preis',
      billingCycle: 'Abrechnungszyklus',
      includedTitle: 'Enthaltene Funktionen',
      moreIncluded: '+{{count}} weitere enthalten',
      paymentTitle: 'Zahlungsdetails',
      paymentIntroTitle: 'Sichere Zahlung',
      paymentIntro: 'Starte die Zahlung, um das sichere Kartenformular zu laden. Du bleibst im Portal.',
      securityNote: 'Sichere Zahlungsabwicklung über Stripe.',
      cardDetails: 'Kartendetails',
      cardDetailsHelp: 'Gib unten deine Kartendaten ein, um fortzufahren.',
      billingLine1: 'Rechnungsadresse',
      billingCity: 'Ort',
      initializePayment: 'Zahlung starten',
      initializingPayment: 'Zahlung wird initialisiert…',
      confirmPay: 'Bestätigen und bezahlen',
      processing: 'Zahlung wird verarbeitet...',
      noPaymentRequired: 'Derzeit ist keine Zahlung erforderlich.',
      missingStripe: 'Stripe ist für diesen Abo-Checkout nicht konfiguriert.',
      successTitle: 'Abonnement aktiviert',
      successDescription: 'Zahlung erfolgreich abgeschlossen. Dein Abonnement ist jetzt aktiv.',
      errors: {
        loadTitle: 'Checkout konnte nicht geladen werden',
        loadDescription: 'Bitte versuche es in einem Moment erneut.',
        intent: 'Zahlung konnte nicht initialisiert werden.',
        clientSecretTitle: 'Zahlungsformular konnte nicht geladen werden',
        clientSecret: 'Die Zahlungsinitialisierung hat eine ungueltige Antwort geliefert. Bitte versuche es erneut.',
        requiredField: 'Dieses Feld ist erforderlich.',
        requiredFieldsMissing: 'Bitte fülle alle erforderlichen Felder aus, um fortzufahren.',
        billingAddressRequired: 'Rechnungsadresse ist erforderlich, um fortzufahren.',
        unavailable: 'Checkout ist für diesen Abo-Status nicht verfügbar.',
        confirm: 'Zahlung konnte nicht bestätigt werden.',
        autoActivation: 'Abonnement konnte nicht automatisch aktiviert werden.',
        autoActivationPending: 'Aktivierung ist noch ausstehend. Bitte in ein paar Sekunden erneut versuchen.',
        autoActivationRequiresPayment: 'Dieser Plan erfordert jetzt eine Zahlung. Bitte mit dem Checkout fortfahren.',
        autoActivationMissingPlan: 'Es wurde kein Plan für die Aktivierung ausgewählt.',
      },
    },
    errors: {
      loadTitle: 'Planverwaltung konnte nicht geladen werden',
      loadDescription: 'Bitte aktualisiere die Seite und versuche es erneut.',
    },
    feedback: {
      checkoutRequired: 'Vor dieser Änderung ist eine Zahlung erforderlich. Bitte schließe den Checkout ab.',
      upgradeSuccess: 'Plan erfolgreich hochgestuft.',
      upgradeError: 'Plan konnte nicht hochgestuft werden.',
      downgradeScheduled: 'Herabstufung für den nächsten Abrechnungszyklus geplant.',
      downgradeScheduledWithDate: 'Herabstufung geplant. Dein aktueller Plan bleibt bis {{date}} aktiv.',
      downgradeError: 'Herabstufung konnte nicht geplant werden.',
      cancelScheduled: 'Kündigung für den nächsten Abrechnungszyklus geplant.',
      cancelScheduledWithDate: 'Kündigung geplant. Dein Plan bleibt bis {{date}} aktiv.',
      cancelError: 'Abonnement konnte nicht gekündigt werden.',
      resumeSuccess: 'Abonnement fortgesetzt.',
      resumeError: 'Abonnement konnte nicht fortgesetzt werden.',
    },
    paymentAction: {
      notice: 'Zur Vervollständigung dieses Upgrades ist eine Zahlungsbestätigung erforderlich.',
      title: 'Zahlung bestätigen, um das Upgrade abzuschließen',
      description: 'Dein Upgrade erfordert eine Zahlungsbestätigung (3D Secure/SCA).',
      confirm: 'Zahlung bestätigen',
      cancel: 'Nicht jetzt',
      processing: 'Wird bestätigt…',
      success: 'Zahlung bestätigt.',
      failed: 'Zahlungsbestätigung fehlgeschlagen.',
      contextError: 'Stripe-Konfiguration konnte nicht geladen werden.',
      missingStripe: 'Stripe ist für dieses Portal nicht konfiguriert.',
      missingClientSecret: 'Daten zur Zahlungsbestätigung fehlen.',
    },
    notices: {
      pendingDowngradeTitle: 'Downgrade geplant',
      pendingDowngradeWithPlan: 'Herabstufung auf {{plan}} für den nächsten Abrechnungszyklus geplant.',
      pendingDowngradeWithPlanAndDate:
        'Herabstufung auf {{plan}} geplant. Dein aktueller Plan bleibt bis {{date}} aktiv.',
    },
    downgradeInfo: {
      teamTitle: 'Downgrade-Optionen sind derzeit nicht verfügbar',
      individualTitle: 'Derzeit sind keine Downgrade-Optionen verfügbar',
      blockedReason: 'Grund: {{reason}}.',
      noEligible: 'Aktuell sind keine berechtigten Downgrade-Optionen verfügbar.',
    },
    downgradeReasons: {
      cancelled_resume_required: 'Dein Abonnement muss fortgesetzt werden, bevor du Pläne wechseln kannst',
      cancelled_checkout_required: 'Für die Reaktivierung ist ein Checkout erforderlich',
      status_disallows_transitions: 'Planwechsel sind für den aktuellen Abo-Status nicht erlaubt',
      no_downgrade_candidates: 'Für dieses Abonnement sind keine Downgrade-Pläne verfügbar',
      downgrade_ineligible: 'Aktuell bist du nicht für ein Downgrade berechtigt',
      no_eligible_downgrade: 'Derzeit sind keine berechtigten Downgrade-Ziele verfügbar',
      seat_limit_exceeded: 'Die aktuelle Sitzplatznutzung überschreitet die Limits niedrigerer Pläne',
      quota_exceeded: 'Die aktuelle Quoten-Nutzung überschreitet die Limits niedrigerer Pläne',
      quota_check_failed: 'Die Quoten-Berechtigung konnte nicht geprüft werden',
      downgrade_not_allowed: 'Downgrade ist nicht erlaubt',
      same_plan: 'Du bist bereits auf diesem Plan',
      pending_change_exists: 'Es existiert bereits eine ausstehende Abo-Änderung',
      billing_action_required: 'Vor dem Downgrade ist eine Abrechnungsaktion erforderlich',
      checkout_required: 'Vor dem Downgrade muss der Checkout abgeschlossen werden',
    },
  },
  billing: {
    title: 'Abrechnung',
    subtitle: 'Verwalte Abonnements, Rechnungen und Zahlungsmethoden.',
    tabs: {
      subscriptions: 'Abonnements',
      credits: 'Credits',
      invoices: 'Rechnungen',
      paymentMethod: 'Zahlungsmethode',
    },
    comingSoon: {
      credits: 'Hier siehst du bald Guthaben, Aufladungen und den Verbrauch.',
      invoices: 'Rechnungen lassen sich hier bald einsehen und herunterladen.',
      paymentMethod: 'Verwalte Karten und Abrechnungskontakte, sobald verfügbar.',
    },
    paymentMethod: {
      subtitle: 'Verwalte die Karte, die für Abonnements und Rechnungen verwendet wird.',
      emptyTitle: 'Keine Zahlungsmethode hinterlegt',
      emptyDescription: 'Füge eine Karte hinzu, um dein Abonnement aktiv zu halten und Rechnungen automatisch zu bezahlen.',
      summary: {
        current: 'Aktuelle Karte',
        exp: 'Gültig bis {{exp}}',
        unknown: 'Karte hinterlegt',
      },
      actions: {
        add: 'Karte hinzufügen',
        update: 'Karte aktualisieren',
        remove: 'Entfernen',
        removing: 'Wird entfernt…',
      },
      updateDisabled: 'Aktualisierungen der Zahlungsmethode sind derzeit für dieses Konto deaktiviert.',
      removeBlockedTitle: 'Entfernen blockiert',
      removeBlockedDescription: 'Diese Zahlungsmethode wird benötigt und kann derzeit nicht entfernt werden.',
      stripeNotConfigured: 'Zahlungen sind für diesen Tenant nicht konfiguriert.',
      stripeErrorTitle: 'Fehler beim Zahlungsanbieter',
      loadErrorTitle: 'Zahlungsmethode konnte nicht geladen werden',
      loadErrorDescription: 'Bitte versuche es in einem Moment erneut.',
      authErrorTitle: 'Nicht autorisiert',
      authErrorDescription: 'Du bist nicht autorisiert. Bitte melde dich erneut an.',
      retry: 'Erneut versuchen',
      removeDialog: {
        title: 'Zahlungsmethode entfernen?',
        description: 'Dadurch wird deine Standard-Zahlungsmethode aus deinem Konto entfernt.',
        cancel: 'Abbrechen',
      },
      dialog: {
        addTitle: 'Zahlungsmethode hinzufügen',
        updateTitle: 'Zahlungsmethode aktualisieren',
        addDescription: 'Gib deine Kartendaten ein, um eine neue Standard-Zahlungsmethode hinzuzufügen.',
        updateDescription: 'Gib deine neuen Kartendaten ein, um deine Standard-Zahlungsmethode zu aktualisieren.',
        loadingElement: 'Sicheres Kartenfeld wird geladen…',
        cancel: 'Abbrechen',
        confirm: 'Speichern',
        processing: 'Wird verarbeitet…',
        errors: {
          confirm: 'Zahlungsmethode konnte nicht bestätigt werden.',
          notSucceeded: 'Setup wurde nicht abgeschlossen. Bitte erneut versuchen.',
          elementLoadTitle: 'Zahlungsfeld konnte nicht geladen werden',
          elementLoad: 'Das Zahlungsfeld konnte nicht geladen werden. Bitte prüfe deine Netzwerkeinstellungen und versuche es erneut.',
          stripeLoadTitle: 'Stripe konnte nicht geladen werden',
          stripeLoad: 'Stripe konnte nicht geladen werden. Bitte prüfe deine Netzwerkeinstellungen und versuche es erneut.',
          intentValidateTitle: 'Setup-Intent kann nicht verwendet werden',
          intentValidate: 'Setup-Intent konnte nicht validiert werden. Bitte erneut versuchen.',
          connectTitle: 'Stripe Connect falsch konfiguriert',
          connect: 'Dieser Tenant verwendet Stripe Connect, aber die Daten des verbundenen Kontos fehlen. Bitte wende dich an den Support.',
          httpsTitle: 'Sichere Verbindung erforderlich',
          https: 'Stripe-Zahlungsfelder erfordern HTTPS (oder localhost). Bitte oeffne diese Seite ueber HTTPS und versuche es erneut.',
          setupIntentTitle: 'Update konnte nicht gestartet werden',
          setupIntent: 'Update der Zahlungsmethode konnte nicht gestartet werden.',
          contextTitle: 'Billing-Kontext konnte nicht geladen werden',
          context: 'Bitte versuche es in einem Moment erneut.',
          missingStripeTitle: 'Stripe nicht verfügbar',
          missingStripe: 'Stripe Publishable Key fehlt für diesen Tenant.',
        },
      },
      feedback: {
        updated: 'Zahlungsmethode aktualisiert.',
        updateFailed: 'Zahlungsmethode konnte nicht aktualisiert werden.',
        finishStripe: 'Schließe den Stripe-Schritt ab und versuche es erneut.',
        refreshRequired: 'Bitte aktualisiere die Seite und versuche es erneut.',
        removed: 'Zahlungsmethode entfernt.',
        removeFailed: 'Zahlungsmethode konnte nicht entfernt werden.',
        removeBlocked: 'Zahlungsmethode kann derzeit nicht entfernt werden.',
      },
    },
    invoices: {
      emptyTitle: 'Noch keine Rechnungen',
      emptyDescription: 'Rechnungen erscheinen hier, sobald eine Abrechnungshistorie verfügbar ist.',
      loadErrorTitle: 'Rechnungen konnten nicht geladen werden',
      loadErrorDescription: 'Bitte versuche es in einem Moment erneut.',
      authErrorTitle: 'Nicht autorisiert',
      authErrorDescription: 'Du bist nicht autorisiert. Bitte melde dich erneut an.',
      retry: 'Erneut versuchen',
      loadMore: 'Mehr laden',
      loadingMore: 'Wird geladen…',
      view: 'Ansehen',
      download: 'PDF herunterladen',
      downloadAria: 'Rechnungs-PDF für {{number}} herunterladen',
      downloadUnavailable: 'Der Rechnungsdownload ist nicht verfügbar.',
      pdfNotAvailable: 'Rechnungs-PDF ist noch nicht verfügbar. Bitte später erneut versuchen.',
      notAuthorized: 'Du bist nicht autorisiert. Bitte melde dich erneut an.',
      notFound: 'Rechnung nicht gefunden.',
      columns: {
        date: 'Datum',
        number: 'Rechnung',
        status: 'Status',
        amount: 'Betrag',
        period: 'Abrechnungszeitraum',
        actions: 'Aktionen',
      },
      status: {
        paid: 'Bezahlt',
        open: 'Offen',
        draft: 'Entwurf',
        void: 'Storniert',
        uncollectible: 'Uneinbringlich',
      },
    },
    credits: {
      title: 'Credits',
      subtitle: 'Überwache Guthaben, Ablaufdaten und Kaufhistorie.',
      availableTitle: 'Verfügbare Credits',
      availableDescription: 'Aktuell verfügbares Guthaben für dein Konto.',
      expiringTitle: 'Läuft in {{days}} Tagen ab',
      expiringDescription: 'Credits, die bald ablaufen.',
      expiringCount: '{{count}} Paket(e)',
      expiringTableTitle: 'Bald ablaufende Credits',
      expiringTableDescription: 'Credits mit nahendem Ablaufdatum basierend auf deinem Guthaben.',
      expiringEmptyTitle: 'Keine Credits laufen bald ab',
      expiringEmptyDescription: 'In den nächsten {{days}} Tagen laufen keine Credits ab.',
      historyTitle: 'Credit-Historie',
      historyDescription: 'Käufe, Nutzung und verbleibende Guthaben je Paket.',
      historyEmptyTitle: 'Noch keine Credit-Historie',
      historyEmptyDescription: 'Deine Credit-Käufe erscheinen hier, sobald vorhanden.',
      loadError: 'Credits konnten nicht geladen werden.',
      retry: 'Erneut versuchen',
      unknownPackage: 'Credit-Paket',
      table: {
        package: 'Paket',
        amount: 'Betrag',
        purchased: 'Gekaufte Credits',
        remaining: 'Verbleibend',
        status: 'Status',
        purchasedAt: 'Gekauft am',
        expiresAt: 'Läuft ab',
        daysUntilExpiry: 'Tage übrig',
      },
      status: {
        completed: 'Abgeschlossen',
        pending: 'Ausstehend',
        failed: 'Fehlgeschlagen',
        canceled: 'Storniert',
        refunded: 'Erstattet',
        expired: 'Abgelaufen',
        unknown: 'Unbekannt',
      },
    },
  },
  } as const;

export default customer;
